import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Vessel.css";
import { toast, ToastContainer } from "react-toastify";

const VesselForm = ({ selectedCompany, vessel, onClose }) => {
  const companyId = selectedCompany?._id;

  // Helper functions to convert between HH.MM format and minutes
  const convertHourStringToMinutes = (timeStr) => {
    const parts = String(timeStr).split(".");
    const hrs = parseInt(parts[0], 10) || 0;
    const mins = parts[1] ? parseInt(parts[1], 10) : 0;
    return hrs * 60 + mins;
  };

  const convertMinutesToHourString = (totalMinutes) => {
    const hrs = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;
    const minsStr = mins < 10 ? `0${mins}` : `${mins}`;
    return `${hrs}.${minsStr}`;
  };

  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [formData, setFormData] = useState(
    vessel
      ? {
          ...vessel,
          job_start: vessel.job_start
            ? new Date(vessel.job_start).toISOString().split("T")[0]
            : "",
          job_end: vessel.job_end
            ? new Date(vessel.job_end).toISOString().split("T")[0]
            : "",
          locationSearch: vessel.supplier.yard_name,
        }
      : {
          vessel_name: "",
          project_code: "",
          job_start: "",
          job_end: "",
          remarks: "",
          supplier: "",
          companyId: companyId || "",
          // piping_dept: {
          //   trade: "",
          //   manual_entry_hrs: "",
          //   isrp_main_hrs: "",
          //   total_hrs_pf: "0.00",
          // },
          // mechanical_dept: {
          //   trade: "",
          //   manual_entry_hrs: "",
          //   isrp_main_hrs: "",
          //   total_hrs_me: "0.00",
          // },
        },
  );

  const sanitizeFormData = (data) => {
    const sanitizedData = { ...data };

    // Remove unwanted fields
    delete sanitizedData.locationSearch;
    delete sanitizedData.showLocationDropdown;

    return sanitizedData;
  };

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [parent, child] = name.split(".");

      setFormData((prevState) => {
        const updatedSection = {
          ...prevState[parent],
          [child]: value,
        };

        // Calculate total hours using HH.MM conversion if manual or ISRP fields are updated
        // if (
        //   parent === "piping_dept" &&
        //   (child === "manual_entry_hrs" || child === "isrp_main_hrs")
        // ) {
        //   const totalMinutes =
        //     convertHourStringToMinutes(updatedSection.manual_entry_hrs || "0") +
        //     convertHourStringToMinutes(updatedSection.isrp_main_hrs || "0");
        //   updatedSection.total_hrs_pf = convertMinutesToHourString(totalMinutes);
        // }

        // if (
        //   parent === "mechanical_dept" &&
        //   (child === "manual_entry_hrs" || child === "isrp_main_hrs")
        // ) {
        //   const totalMinutes =
        //     convertHourStringToMinutes(updatedSection.manual_entry_hrs || "0") +
        //     convertHourStringToMinutes(updatedSection.isrp_main_hrs || "0");
        //   updatedSection.total_hrs_me = convertMinutesToHourString(totalMinutes);
        // }

        return {
          ...prevState,
          [parent]: updatedSection,
        };
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Optionally, recalculate totals if needed when hours change
  useEffect(
    () => {
      setFormData((prevState) => ({
        ...prevState,
        // piping_dept: {
        //   ...prevState.piping_dept,
        //   total_hrs_pf: convertMinutesToHourString(
        //     convertHourStringToMinutes(prevState.piping_dept.manual_entry_hrs || "0") +
        //       convertHourStringToMinutes(prevState.piping_dept.isrp_main_hrs || "0")
        //   ),
        // },
        // mechanical_dept: {
        //   ...prevState.mechanical_dept,
        //   total_hrs_me: convertMinutesToHourString(
        //     convertHourStringToMinutes(prevState.mechanical_dept.manual_entry_hrs || "0") +
        //       convertHourStringToMinutes(prevState.mechanical_dept.isrp_main_hrs || "0")
        //   ),
        // },
      }));
    },
    [
      // formData.piping_dept.manual_entry_hrs,
      // formData.piping_dept.isrp_main_hrs,
      // formData.mechanical_dept.manual_entry_hrs,
      // formData.mechanical_dept.isrp_main_hrs,
    ],
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedCompany?.status === false) {
      toast.error("The company is not active");
      return;
    }
    setLoading(true);

    const { createdBy, ...submissionData } = {
      ...formData,
      companyId: companyId || formData.companyId,
    };

    const sanitizedData = sanitizeFormData(submissionData);

    try {
      if (vessel) {
        await axiosInstance.patch(`/vessel/${vessel._id}`, sanitizedData);
      } else {
        await axiosInstance.post("/vessel", sanitizedData);
      }
      onClose();
      toast.success(vessel ? "Updated successfully" : "Added Successfully");
    } catch (error) {
      // console.error("Error saving vessel:", error);

      let errorMessage = "Error saving vessel";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = Array.isArray(error.response.data.message)
          ? error.response.data.message[0]
          : error.response.data.message;
      }
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axiosInstance.get("/vessel/location");
        setLocations(response.data.data);
      } catch (error) {
        toast.error(error.message);
      }
    };
    fetchLocations();
  }, []);

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <ToastContainer />
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">
              {vessel ? "Edit Vessel" : "Create Vessel"}
            </h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <form onSubmit={handleSubmit}>
              {/* Vessel Details Section */}
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Vessel Details
                  </h5>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Vessel Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vessel_name"
                        value={formData.vessel_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label">Project Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="project_code"
                        value={formData.project_code}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3  position-relative">
                      <label className="form-label">Supplier</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type location name or code"
                        value={
                          locations.find(
                            (item) => item._id === formData.supplier,
                          )?.yard_name ||
                          formData.locationSearch ||
                          ""
                        }
                        onChange={(e) => {
                          const searchValue = e.target.value;
                          setFormData({
                            ...formData,
                            locationSearch: searchValue,
                            supplier: "",
                          });
                        }}
                        onFocus={() =>
                          setFormData({
                            ...formData,
                            showLocationDropdown: true,
                          })
                        }
                        required
                      />
                      {formData.showLocationDropdown && (
                        <ul
                          className="list-group position-absolute"
                          style={{
                            zIndex: 1200,
                            width: "100%",
                            maxHeight: 220,
                            overflowY: "auto",
                          }}
                        >
                          {locations
                            .filter(
                              (item) =>
                                item.yard_name
                                  .toLowerCase()
                                  .includes(
                                    formData.locationSearch?.toLowerCase() ||
                                      "",
                                  ) ||
                                item.code
                                  .toLowerCase()
                                  .includes(
                                    formData.locationSearch?.toLowerCase() ||
                                      "",
                                  ),
                            )
                            .map((item) => (
                              <li
                                key={item._id}
                                className="list-group-item list-group-item-action"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setFormData({
                                    ...formData,
                                    supplier: item._id,
                                    locationSearch: "",
                                    showLocationDropdown: false,
                                  });
                                }}
                              >
                                {`${item.yard_name} - ${item.code}`}
                              </li>
                            ))}
                          {locations.filter(
                            (item) =>
                              item.yard_name
                                .toLowerCase()
                                .includes(
                                  formData.locationSearch?.toLowerCase() || "",
                                ) ||
                              item.code
                                .toLowerCase()
                                .includes(
                                  formData.locationSearch?.toLowerCase() || "",
                                ),
                          ).length === 0 && (
                            <li className="list-group-item list-group-item-action">
                              No results found
                            </li>
                          )}
                        </ul>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Job Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="job_start"
                        value={formData.job_start}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Job End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="job_end"
                        value={formData.job_end}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Remark</label>
                      <textarea
                        type="text"
                        className="form-control custom-textarea"
                        name="remarks"
                        value={formData.remarks}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Piping Department Section */}
              {/* <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Piping Department
                  </h5>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Trade</label>
                      <input
                        type="text"
                        className="form-control"
                        name="piping_dept.trade"
                        value={formData.piping_dept.trade}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Manual Entry Hours</label>
                      <input
                        type="text"
                        className="form-control"
                        name="piping_dept.manual_entry_hrs"
                        value={formData.piping_dept.manual_entry_hrs}
                        onChange={handleChange}
                        placeholder="HH.MM"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">ISRP Man Hours</label>
                      <input
                        type="text"
                        className="form-control"
                        name="piping_dept.isrp_main_hrs"
                        value={formData.piping_dept.isrp_main_hrs}
                        onChange={handleChange}
                        placeholder="HH.MM"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Total Hours (PF)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="piping_dept.total_hrs_pf"
                        value={formData.piping_dept.total_hrs_pf}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Mechanical Department Section */}
              {/* <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Mechanical Department
                  </h5>
                  <div className="row">
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Trade</label>
                      <input
                        type="text"
                        className="form-control"
                        name="mechanical_dept.trade"
                        value={formData.mechanical_dept.trade}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Manual Entry Hours</label>
                      <input
                        type="text"
                        className="form-control"
                        name="mechanical_dept.manual_entry_hrs"
                        value={formData.mechanical_dept.manual_entry_hrs}
                        onChange={handleChange}
                        placeholder="HH.MM"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">ISRP Man Hours</label>
                      <input
                        type="text"
                        className="form-control"
                        name="mechanical_dept.isrp_main_hrs"
                        value={formData.mechanical_dept.isrp_main_hrs}
                        onChange={handleChange}
                        placeholder="HH.MM"
                      />
                    </div>
                    <div className="col-md-3 mb-3">
                      <label className="form-label">Total Hours (ME)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="mechanical_dept.total_hrs_me"
                        value={formData.mechanical_dept.total_hrs_me}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Submit Button */}
              <div className="text-center">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading
                    ? vessel
                      ? "Updating..."
                      : "Adding..."
                    : vessel
                      ? "Update"
                      : "Add Vessel"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VesselForm;
